import { BANNER_DIMENSION } from "./Banner.constant";

export const validateImageDimensions = (file, bannerType) => {
   if (!(file instanceof File)) {
    throw new Error("Invalid file selected");
  }
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;
      const requiredDimension = BANNER_DIMENSION[bannerType];

      if (
        width === requiredDimension.width &&
        height === requiredDimension.height
      ) {
        resolve(true);
      } else {
        reject(
          new Error(
            `Required: ${requiredDimension.width}×${requiredDimension.height}px. Uploaded: ${width}×${height}px`,
          ),
        );
      }
    };

    img.onerror = () => reject(new Error("Invalid image file"));
    img.src = URL.createObjectURL(file);
  });
};